import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#about', label: 'About' },
    { href: '#services', label: 'Services' },
    { href: '#technology', label: 'Technology' },
    { href: '#process', label: 'Process' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__inner">
        <Link to="/" className="navbar__logo">
          <svg viewBox="0 0 40 40" className="navbar__logo-icon">
            <defs>
              <linearGradient id="navGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#00d4ff"/>
                <stop offset="100%" stopColor="#7c3aed"/>
              </linearGradient>
            </defs>
            <path d="M20 4L10 14l3 5-5 11h8l2.5-4L20 30l1.5-4L24 30h8l-5-11 3-5L20 4zm0 5l5 6-1.5 3.5h-7L15 15l5-6z" fill="url(#navGrad)"/>
          </svg>
          <span className="navbar__logo-text">
            <strong>Wolf</strong>Technologies
          </span>
        </Link>

        <div className={`navbar__links ${mobileOpen ? 'navbar__links--open' : ''}`}>
          {isHome ? (
            <>
              {navLinks.map(link => (
                <a
                  key={link.href}
                  href={link.href}
                  className="navbar__link"
                  onClick={() => setMobileOpen(false)}
                >
                  {link.label}
                </a>
              ))}
              <Link to="/portfolio" className="navbar__link" onClick={() => setMobileOpen(false)}>
                Portfolio
              </Link>
              <a href="#contact" className="btn btn--small btn--primary" onClick={() => setMobileOpen(false)}>
                Get Started
              </a>
            </>
          ) : (
            <>
              <Link to="/" className="navbar__link" onClick={() => setMobileOpen(false)}>
                Home
              </Link>
              <Link to="/portfolio" className="navbar__link" onClick={() => setMobileOpen(false)}>
                Portfolio
              </Link>
              <Link to="/" className="btn btn--small btn--primary" onClick={() => setMobileOpen(false)}>
                Back to Home
              </Link>
            </>
          )}
        </div>

        <button
          className={`navbar__hamburger ${mobileOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
